import { CSSProperties } from "react"

interface SkeletonProps {
  width?: number
  height?: number
  size?: number
  rounded?: boolean
  radius?: number
}
export const Skeleton = ({ radius, size, width, height, rounded }: SkeletonProps) => {
  let style: CSSProperties = { width, height }
  if (size != null) style = { width: size, height: size, minWidth: size, borderRadius: 4 }
  if (rounded != null && size != null) Object.assign(style, { borderRadius: size * 2 })
  if (radius != null) Object.assign(style, { borderRadius: radius })
  return <div style={style} className="loader" />
}
